var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-layout"},[_c('LoginFormCom',{attrs:{"type":"登录","form-data":_vm.formData},on:{"submitForm":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }